<template>
  <div
    v-bind="$data"
    class="e-form-checkbox"
    :class="[{ checked: value, 'has-error': errorMsg, disabled }]"
  >
    <div class="e-form-checkbox__title" v-html="title" v-if="!$isNoE(title)" />
    <div class="e-form-checkbox__main">
      <div
        class="e-form-checkbox__check"
        @click="toggle"
        @keydown="handleKeyDown"
        :tabindex="disabled ? -1 : 0"
        role="checkbox"
        :aria-checked="value"
        :aria-disabled="disabled"
        v-if="!hideCheckBox"
      >
        <Icon name="check" />
      </div>
      <div
        class="e-form-checkbox__label"
        v-html="errorMsg ?? mandatoryText"
        v-if="mandatoryText"
        @click="toggle"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  emits: ['change', 'update:value', 'a-click'],
  props: {
    value: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    mandatoryText: {
      type: String,
    },
    errorMsg: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideCheckBox: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const methods = {
      toggle(e) {
        if (e.target?.tagName === 'A') {
          ctx.emit('a-click', e);
          return;
        }
        if (!props.disabled) {
          ctx.emit('update:value', !props.value);
          ctx.emit('change', e, !props.value);
        }
      },
      handleKeyDown(e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          this.toggle(e);
        }
      },
    };
    return {
      ...methods,
    };
  },
};
</script>

<style lang="scss">
@import '../styles/variables';
@import '../styles/functions';
@import '../styles/mixins';
.e-form-checkbox {
  font-size: 14px;
  $c: &;
  &__title {
    margin-bottom: $space-24;
  }
  &__main {
    display: flex;
    gap: $space-10;
    align-items: center;
  }
  &__check {
    width: 14px;
    height: 14px;
    border: 1px solid $black;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;
    outline: none;

    &:focus {
      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);
    }

    .e-icon {
      opacity: 0;
      transition: all 0.2s ease;
      transform: scale(0.5);
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
  &__label {
    cursor: pointer;
    flex-grow: 1;
    color: $black;
    user-select: none;
    a {
      color: $black;
      text-decoration: underline;
      outline: none;

      &:focus {
        outline: none;
      }
    }
  }
  &.checked {
    #{$c}__check {
      background: $blue-night;
      border-color: $black;
      color: $white;
      .e-icon {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
  &.has-error {
    #{$c}__label {
      color: $red;
      a {
        color: $red;
      }
    }
  }
  &.disabled {
    color: $grey;
    #{$c}__check {
      background: $grey-light;
      border-color: $grey-light;
      cursor: default;
    }
    #{$c}__label {
      cursor: default;
    }
  }
  @include desktop {
  }
}
.theme-blue {
  .e-form-checkbox {
    $c: &;
    &__check {
      border: 1px solid $white;

      &:focus {
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
      }
    }
    &__label {
      color: $white;
      a {
        color: $white;
        outline: none;

        &:focus {
          outline: none;
        }
      }
    }
    &.checked {
      .e-form-checkbox__check {
        background: transparent;
        border-color: $white;
        color: $white;
      }
    }
  }
}
</style>
